



















import Vue, { PropType } from 'vue'
import { expansionPanelStates, ExpansionPanelStateTypes } from '@/components/InstallDevices/constants'

const { DISABLED, ENABLED, INVALIDATED, VALIDATED } = expansionPanelStates

export default Vue.extend({
  name: 'ExpansionPanel',
  props: {
    title: String,
    expansionPanelState: String as PropType<ExpansionPanelStateTypes>,
    formIndex: Number
  },
  computed: {
    computedState () {
      switch (this.expansionPanelState) {
        case DISABLED:
          return { icon: '', iconColor: '', disabled: true, hideActions: true }
        case ENABLED:
          return { icon: '', iconColor: '', disabled: false, hideActions: false }
        case VALIDATED:
          return { icon: 'fas fa-check', iconColor: 'success', disabled: false, hideActions: false }
        case INVALIDATED:
          return { icon: 'fas fa-exclamation', iconColor: 'danger', disabled: false, hideActions: false }
        default:
          return { icon: '', disabled: true, iconColor: '', hideActions: true }
      }
    }
  }
})
